import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { StepState, StepChange } from 'app/shared/components/happy/happy-stepper/happy-stepper.component';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Router } from '@angular/router';
import { BuyerToSellerService } from './buyer-to-seller.service';
import { RxComponent } from '../../common/rx.component';
import { PermissionsService } from 'app/core/services/permissions.service';

@Component({
  selector: 'itpx-buyer-to-seller',
  templateUrl: './buyer-to-seller.component.html',
  styleUrls: ['./buyer-to-seller.component.css']
})
export class BuyerToSellerComponent extends RxComponent implements OnInit, OnDestroy {
  @Input() authSignatory: { signatory: boolean };
  @Input() signatoriesList: any[];
  @Input() isPublic: boolean;

  private tabs: Array<any>;
  private stepState$: Observable<StepState>;
  private stepClicked$ = new Subject<StepChange>();
  private proceed = new Subject<string>();

  private initialState: StepState;

  private state: StepState;
  enabled: boolean[];
  loaded$: Observable<any>;

  constructor(
    private router: Router,
    private service: BuyerToSellerService,
    private permissionsService: PermissionsService
  ) {
    super();
  }

  ngOnInit() {
    this.tabs = [
      { key: 'benefits', icon: 'fa fa-cogs', title: 'How it works' },
      { key: 'termsConditions', icon: 'fa fa-list-alt', title: 'Terms And Conditions' },
      { key: 'nextSteps', icon: 'fa fa-location-arrow', title: 'Next Steps'}
    ];

    this.initialState = {
      steps: this.tabs,
      currentStep: 0,
      previousStep: 0,
      completedStep: 0,
      strictLinearMode: true
    };
    
    this.state = { ...this.initialState };
    
    this.enabled = [true, false, true];
    this.initiateStepper();
    this.loaded$ = this.service.getTermsAndConditions();
  }

  initiateStepper() {
    this.stepState$ = this.stepClicked$
      .scan((state, newStep) => StepState.changeStep(state, newStep), this.initialState)
      .startWith(this.initialState)
      .shareReplay();

    this.stepState$.subscribe(input => {
      this.state = input;
    });
  }

  private back() {
    let currentStep = this.state.currentStep;
    if (0 < currentStep) {
      this.goToStep(currentStep - 1);
    } else {
      this.router.navigate(['/dashboard']);
    }
  }

  private goToStep(step: number, maxStep?: number) {
    const change = new StepChange(step, maxStep);
    this.stepClicked$.next(change);
  }

  private next() {
    this.proceed.next(this.state.steps[this.state.currentStep].key);
  }

  private canProceed(event: boolean) {
    if (!event)
      return;
    let currentStep = this.state.currentStep;
    if (this.tabs.length - 1 > currentStep) {
      this.goToStep(currentStep + 1);
    } else {
      this.router.navigate(['/dashboard']);
    }
  }

  private enable(event: any, idx: number) {
    this.enabled[idx] = event;
  }

  ngOnDestroy() {
    this.service.kill();
    super.ngOnDestroy();
  }
}



// WEBPACK FOOTER //
// ./src/app/core/components/buyer-to-seller-wrapper/buyer-to-seller/buyer-to-seller.component.ts